module.exports = __webpack_public_path__ + "img/content_r.f0e43b07.png";